import axios, { AxiosResponse } from 'axios'
import { IFetchDiagnosesParams, IDiagnosis } from '~/interfaces'

const { REACT_APP_API_HSTORY_URL: hstoryAPI } = process.env

export const fetchDiagnoses = async (params: IFetchDiagnosesParams): Promise<IDiagnosis[]> => {
  const { patientId } = params
  const response = await axios.get(`${hstoryAPI}/patients/${patientId}/diagnoses`)
  const { data }: AxiosResponse<IDiagnosis[]> = response
  return data
}
